module.exports = __webpack_public_path__ + "static/media/chores.90890bf9.svg";